// Saved Write model ids can outlive their picker entries. Keep replacements in
// one shared registry so every Write surface preserves the intended model family.
// Phase 1 turtle candidates were removed when Phase 2 launched; saved turtle
// and blinded-letter values fall back to the default Write model. Ledger labels
// are kept for provenance.
export const WRITE_MODEL_FALLBACKS = Object.freeze({
  balanced: "excellent",
  gpt41nano: "gpt56luna",
  claude3haiku: "claude55haiku",
  claude35haiku: "claude55haiku",
  claude4sonnet: "claude46sonnet",
  claude4opus: "claude48opus",
  // The Muse 2 alpha ran one blinded letter per model family before it settled
  // on a single codenamed candidate per family. Both generations are retired.
  muse2alphaa: "excellent",
  muse2alphab: "excellent",
  muse2alphac: "excellent",
  muse2alphad: "excellent",
  muse2leonardo: "excellent",
  muse2michelangelo: "excellent",
  muse2donatello: "excellent",
  muse2raphael: "excellent",
});

export function resolveWriteModelFallback(writeModel) {
  if (typeof writeModel !== "string") return writeModel;

  let resolved = writeModel.trim();
  const visited = new Set();

  while (resolved) {
    const key = resolved.toLowerCase();
    if (visited.has(key)) break;
    visited.add(key);

    const replacement = WRITE_MODEL_FALLBACKS[key];
    if (!replacement) break;
    resolved = replacement;
  }

  return resolved;
}
